<template>
  <div>
    <a-upload
      :list-type="listType"
      :file-list="fileList"
      :multiple="isMultiple"
      :remove="removeFile"
      @preview="handlePreview"
      :customRequest="customRequest"
    >
      <div v-if="fileList.length < maxLength">
        <div v-if="listType == 'picture-card'">
          <a-icon type="plus" v-if="isShowIcon" />
          <div class="ant-upload-text">{{ tips }}</div>
        </div>
        <a-button v-if="listType == 'text' || listType == 'picture'">
          <a-icon type="upload" v-if="isShowIcon" />
          {{ tips }}
        </a-button>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" @close="previewImage = ''" :zIndex="9999" class="upload-preview">
      <div style="height: 20px;"></div>
      <img style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    listType: {
      type: String,
      default: "picture-card"
    },
    isShowIcon:{
      type: Boolean,
      default: true
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    // image : 图片
    // application ：程序文件
    // text ：text 文件
    // sheet ：excel 文件
    // document ：doc 文件
    // all ：全
    fileType: {
      type: String,
      default: "image"
    },
    // 单个文件大小 10M
    maxSize: {
      type: [Number, String],
      default: 10
    },
    maxLength: {
      type: [Number, String],
      default: 1
    },
    value: {
      type: Array,
      default: () => []
    },
    uploadFilesFn: {
      type: Function,
      default: null
    },
    downloadFileFn: {
      type: Function,
      default: null
    },
    // 扩展参数
    extend: {
      type: Object,
      default: null
    },
    // 是否显示文件列表
    // 配合 v-model 使用，false v-model 不传
    isShowFile: {
      type: Boolean,
      default: true
    },
    tips: {
      type: String,
      default: "上传附件"
    },
    limitType: {
      type: Array,
      default: () => [
        "JPG",
        "JPEG",
        "PNG",
        "BMP",
        "GIF",
        "SVG",
        "RM",
        "RMVB",
        "MPEG",
        "AVI",
        "MP4",
        "3GP",
        "FLV",
        "WMV",
        "SWF",
        "MPG",
        "3GP2",
        "ASF",
        'H264',
        "MPEG1",
        "MPEG2",
        "MPEG3",
        "MPEG4",
        "FLV1",
        "DOC",
        "DOCX",
        "PPT",
        "PPTX",
        "XLS",
        "XLSX",
        "VSD",
        "POT",
        "PPS",
        "RTF",
        "WPS",
        "ET",
        "DPS",
        "PDF",
        "TXT",
        "EPUB",
        "RAR",
        "RAR5",
        "ZIP",
        "7Z",
      ]
    },
    sizeMessage:{
      type: String,
      default: `仅支持2M以内的图片附件上传!`
    },
    isLoad: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val?.length) {
          val.map(item => {
            item["url"] = this.downloadFileFn({
              fileId: item.uid,
              fileName: item.name
            });
          });
          this.fileList = val;
        } else {
          this.fileList = [];
        }
      }
    },
    fileList:{
      immediate: true,
      handler(val){
        if (val?.length) {
          let valFalg = val.some(x => x.status == 'uploading');
          this.$emit('update:isLoad',valFalg);
        }else{
          this.$emit('update:isLoad',false)
        }
      },
      deep:true
    }
  },
  name: "upload",
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      fileList: []
    };
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    // 预览
    handlePreview(file) {
      let { url, name } = file;
      let nameSuffix = name.substring(file.name.lastIndexOf(".") + 1).toUpperCase();
      if (!["JPG","JPEG","PNG","BMP","GIF"].includes(nameSuffix)) {
        const a = document.createElement("a");
        a.download = name;
        a.href = url;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return;
      }
      this.previewImage = url;
      this.previewVisible = true;
    },
    // 移除
    removeFile(parmas) {
      let { uid } = parmas;
      this.fileList = this.fileList.filter(item => item.uid != uid);
      this.$emit("change", this.fileList);
    },
    // 上传
    async customRequest(parmas) {
      const { file } = parmas;
      let isImage = true;

      if (this.limitType.length) {
        let typeName = file.name.substring(file.name.lastIndexOf(".") + 1);
        typeName = typeName.toUpperCase();
        isImage = this.limitType.includes(typeName);
      }
      // 判断格式正确
      if (!isImage) {
        // let msg = ["JPG", "JPEG", "PNG", "BMP", "GIF"].join() == this.limitType.join() ? this.sizeMessage : '文件格式不符'
        this.$message.warning('上传附件的格式错误！');
        return;
      }
      // 判断文件大小
      const isLt2M = file.size / 1024 / 1024 < Number(this.maxSize);
      if (!isLt2M ) {
        this.$message.warning(`仅支持${this.maxSize}M附件上传`);
        return;
      }

      if( /[^a-zA-Z0-9_ \u4e00-\u9fa5．，.,。]/.test(file.name))
      {
        this.$message.warning('上传附件的名字不能带有特殊符号！');
        return false;
      }


      // 上传图片
      let formData = new FormData();
      formData.append("files", file);
      let res = null;
      let index = this.fileList.length
      if (this.isShowFile) {
        this.fileList.push({
          uid:file.uid,
          name:file.name,
          status:'uploading'
        })
      }
      if (this.extend) {
        res = await this.uploadFilesFn(this.extend, formData);
      } else {
        res = await this.uploadFilesFn(formData);
      }
      if (res.code == 200) {
        let fileData = JSON.parse(res.data);
        let fileList = JSON.parse(JSON.stringify(this.fileList));
        // fileList.push({
        //   uid: Object.keys(fileData)[0],
        //   name: Object.values(fileData)[0],
        //   status: "done",
        //   url: this.downloadFileFn({
        //     fileId: Object.keys(fileData)[0],
        //     fileName: Object.values(fileData)[0]
        //   })
        // });
        fileList.splice(index,1,{
          uid: Object.keys(fileData)[0],
          name: Object.values(fileData)[0],
          status: "done",
          url: this.downloadFileFn({
            fileId: Object.keys(fileData)[0],
            fileName: Object.values(fileData)[0]
          })
        })
        this.$emit("change", fileList);
        if (this.isShowFile) {
          this.fileList = fileList;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .ant-upload-list-item-uploading-text{
  font-size: 12px;
}
</style>
